import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";

class Footer extends React.Component {
  render() {
    return (
      <div>
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div
                style={{ marginTop: "1%" }}
                className="col-lg-4 col-md-3 col-xs-12"
              >
                <div className="footer-logo">
                  <img
                    src="assets/img/logo-footer.png"
                    alt="compamies using the jira plugin free timesheets for jira from the market place"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-xs-12">
                <p className="float-right">
                  <a href="" rel="nofollow"></a>
                </p>
              </div>
              <div
                style={{ marginTop: "1%" }}
                className="col-lg-4 col-md-5 col-xs-12"
              >
                <table style={{ padding: "0", margin: "0", color: "white" }}>
                  <tbody>
                    <tr>
                      <td>Address:</td>
                      <td>7 Quai du Mont-Blanc</td>
                    </tr>
                    <tr>
                      <td>City:</td>
                      <td>Geneva 1205, Switzerland</td>
                    </tr>
                    <tr>
                      <td>Email:</td>
                      <td>touchdownatlassian@gmail.com</td>
                    </tr>
                    <tr>
                      <td>TouchDownApps</td>
                      <td>
                        <Link
                          className="nav-link"
                          to={{ pathname: "/privacy", hash: "#privacyPage" }}
                        >
                          Privacy policy
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <a href="#" className="back-to-top">
          <i className="lni-arrow-up"></i>
        </a>
        <div id="preloader">
          <div className="loader" id="loader-1"></div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js